import { DELIVERY_ADDRESSES_CLEAR } from "./DeliveryAddressesActionTypes";

export const clearDeliveryAddressesAction = () => (dispatch: any) => {
  dispatch({ type: DELIVERY_ADDRESSES_CLEAR });
};
